import { Box, LinearProgress, Typography } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';

const downloadingSegmentsMessage = defineMessage({
  id: 'logger.downloadingSegments',
  defaultMessage: 'Downloading segments {progress}%',
});

export const CachedSegmentsProgress = ({ progress }: { progress: number }) => {
  const { $t } = useIntl();

  if (progress >= 100) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{ flex: 1, height: 12, borderRadius: 0 }}
      />
      <Typography variant="caption" color="text.secondary">
        {$t(downloadingSegmentsMessage, { progress })}
      </Typography>
    </Box>
  );
};
